import React, { useMemo, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@shadcn-in-nx/ui/card";
import { Button } from "@shadcn-in-nx/ui/button";
import { Badge } from "@shadcn-in-nx/ui/badge";
import { Input } from "@shadcn-in-nx/ui/input";
import { X, Search } from "lucide-react";

export default function UserDrillDown({ users, filterType, filterValue, onClose }) {
    const [search, setSearch] = useState("");

    const filtered = useMemo(() => {
        let list = users.filter((u) => {
            const field = filterType === "role" ? u.role : u.industry;
            return (field || "Not specified") === filterValue;
        });
        if (search) {
            const q = search.toLowerCase();
            list = list.filter(
                (u) =>
                    u.firstName?.toLowerCase().includes(q) ||
                    u.lastName?.toLowerCase().includes(q) ||
                    u.email?.toLowerCase().includes(q) ||
                    u.buildingGoal?.toLowerCase().includes(q)
            );
        }
        return list;
    }, [users, filterType, filterValue, search]);

    return (
        <Card>
            <CardHeader className="pb-3">
                <div className="flex items-center justify-between">
                    <CardTitle className="text-base flex items-center gap-2">
                        Users with {filterType}: <Badge variant="secondary">{filterValue}</Badge>
                        <span className="text-muted-foreground font-normal">({filtered.length})</span>
                    </CardTitle>
                    <Button variant="ghost" size="icon" onClick={onClose}>
                        <X className="h-4 w-4" />
                    </Button>
                </div>
                <div className="relative mt-2">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                    <Input
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search users or goals..."
                        className="pl-9"
                    />
                </div>
            </CardHeader>
            <CardContent>
                <div className="max-h-96 overflow-y-auto space-y-2">
                    {filtered.length === 0 ? (
                        <p className="text-sm text-muted-foreground text-center py-4">No users found</p>
                    ) : (
                        filtered.map((u) => (
                            <div key={u.id} className="border rounded-md p-3 space-y-1">
                                <div className="flex items-center justify-between">
                                    <span className="text-sm font-medium">
                                        {u.firstName} {u.lastName}
                                    </span>
                                    <span className="text-xs text-muted-foreground">{u.email}</span>
                                </div>
                                <div className="flex gap-1.5 flex-wrap">
                                    {u.role && <Badge variant="outline" className="text-xs">Role: {u.role}</Badge>}
                                    {u.industry && <Badge variant="outline" className="text-xs">Industry: {u.industry}</Badge>}
                                    {u.blueprintCategorized && <Badge className="text-xs bg-green-100 text-green-800">Categorized</Badge>}
                                </div>
                                {u.buildingGoal && (
                                    <p className="text-sm text-muted-foreground bg-muted rounded px-2 py-1 mt-1">
                                        {u.buildingGoal}
                                    </p>
                                )}
                            </div>
                        ))
                    )}
                </div>
            </CardContent>
        </Card>
    );
}
